/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Injectable } from '@angular/core';
import { Admin, DistrictShort, SchoolShort } from 'src/app/shared/graphql';

@Injectable({
  providedIn: 'root'
})
export class StorageV3Service {

   addSchoolToDistrict(districtId: string, newSchool: SchoolShort): void {
    // Obtener el dato actual de sessionStorage
    const currentDataStr = sessionStorage.getItem('current');
    if (!currentDataStr) return;
  
    try {
      const currentData = JSON.parse(currentDataStr);
      if(currentData){
           // Buscar el distrito por ID
      const districtIndex = currentData?.districts?.findIndex(
        (d: any) => d?.districtId === districtId
      );
  
      if (districtIndex !== -1) {
        // Verificar si schools existe, si no, inicializarlo como array vacío
        if (!currentData?.districts[districtIndex].schools) {
          currentData.districts[districtIndex].schools = [];
        }
        
        // Agregar la nueva escuela
        currentData.districts[districtIndex].schools.push({
          __typename: 'SchoolShort',
          ...newSchool
        });
  
        // Guardar de vuelta en sessionStorage
        sessionStorage.setItem('current', JSON.stringify(currentData));  
       }      
     
      }
    } catch (error) {
      console.error('Error updating sessionStorage:', error);
    }
  }

  removeSchoolFromDistrict(districtId: string, schoolId: string): boolean {
    try {
        // 1. Obtener y validar datos actuales
        const currentDataStr = sessionStorage.getItem('current');
        if (!currentDataStr) {
             return false;
        }

        const currentData = JSON.parse(currentDataStr);
        
        // 2. Validar estructura básica
        if (!currentData?.districts || !Array.isArray(currentData.districts)) {
            return false;
        }

        // 3. Buscar y actualizar el distrito específico
        const districtIndex = currentData.districts.findIndex(
            (d: any) => d?.districtId === districtId
        );

        if (districtIndex === -1) {          
            return false;
        }

        // 4. Clonar y actualizar de forma inmutable
        const updatedDistricts = [...currentData.districts];
        const districtToUpdate = updatedDistricts[districtIndex];
        
        if (!districtToUpdate.schools) {
            return false;
        }

        updatedDistricts[districtIndex] = {
            ...districtToUpdate,
            schools: districtToUpdate.schools.filter(
                (s: any) => s?.schoolId !== schoolId
            )
        };

        // 5. Actualizar sessionStorage
        sessionStorage.setItem('current', JSON.stringify({
            ...currentData,
            districts: updatedDistricts
        }));

        return true;
    } catch (error) {
        return false;
    }
 }

  getDistricts(): Array<DistrictShort> | null {
    try {
      // Obtener el dato actual de sessionStorage
      const currentDataStr = sessionStorage.getItem('current');
      if (!currentDataStr) return null;
  
      const currentData = JSON.parse(currentDataStr);
      
      // Verificar si existe la propiedad districts
      if (currentData.districts && Array.isArray(currentData.districts)) {
        return currentData.districts;
      }
      
      return null;
    } catch (error) {
      console.error('Error updating sessionStorage when adding school:', error);
      return null;
    }
  }

  setCurrent(admin: Admin): void {
    sessionStorage.setItem('current', JSON.stringify(admin));
  }

  getCurrent(): Admin | null {
    try {
      const currentData = sessionStorage.getItem('current');      
      if (!currentData) {
        return null;
      }
  
      const parsedData: Admin = JSON.parse(currentData);
      
      // Basic validation of required fields
      if (!parsedData.id || !parsedData.name || !parsedData.email || !parsedData.role) {
        return null;
      }
  
      // Ensure districts exists and is an array (initialize if missing)
      if (!parsedData.districts || !Array.isArray(parsedData.districts)) {
        parsedData.districts = [];
      }
  
      return parsedData;
    } catch (error) {
      return null;
    }
  }

  removeCurrent(): void {
    sessionStorage.removeItem('current');
  }


  updateDistrictsInCurrent(districts: DistrictShort[]): boolean {
    try {
      const currentData = sessionStorage.getItem('current');
      if (!currentData) {      
        return false;
      }

      const currentObj: Admin = JSON.parse(currentData);

      const updatedCurrent = {
        ...currentObj,
        districts: [...districts]
      };

      sessionStorage.setItem('current', JSON.stringify(updatedCurrent));

      return true;
    } catch (error) {
      console.error('Error al actualizar distritos en sessionStorage:', error);
      return false;
    }
  }

  getLastSchoolId(): string | null {
     const stLastSchool = sessionStorage.getItem('lastSchool');
     return stLastSchool ;
  }

  setLastSchoolId(schoolId: string): void {
    sessionStorage.setItem('lastSchool', schoolId);
  }
}